<template>
  <div class="dol-clock">
    <div class="dol-clock-plate" :style="{height: size + 'px', width: size + 'px', fontSize: fontSize + 'px'}">
      <div class="dol-clock-hour">
        <div
          class="dol-clock-item "
          v-for="(item, index) in minutes"
          :key="item"
          :style="{
          width: numberSize + 'px',
          height: numberSize + 'px',
          lineHeight: numberSize + 'px',
          top: innerRadius * (1 - Math.cos(Math.PI * 2 * index / minutes.length)) + innerOffset + 'px',
          left: innerRadius * (1 + Math.sin(Math.PI * 2 * index / minutes.length)) + innerOffset + 'px',
        }"
          :class="{active: item == innerValue[1]}"
          @click="pickMinute(item)"
        >
          {{item}}{{item===0 ? 'min' : ''}}
        </div>
      </div>
      <div class="dol-clock-hour">
        <div
          class="dol-clock-item dol-clock-item__minute"
          v-for="(item, index) in hours"
          :key="item"
          :style="{
          width: numberSize + 'px',
          height: numberSize + 'px',
          lineHeight: numberSize + 'px',
          top: outerRadius * (1 - Math.cos(Math.PI * 2 * index / hours.length)) + outerOffset + 'px',
          left: outerRadius * (1 + Math.sin(Math.PI * 2 * index / hours.length)) + outerOffset + 'px',
        }"
          :class="{active: item == innerValue[0], disabled: item < startHour || item > endHour}"
          @click="pickHour(item)"
        >
          {{item}}{{item===0 ? 'h': ''}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dol-clock",
  props: {
    value: {type: String, default: '08:00'},
    size: {type: Number, default: 240},
    fontSize: {type: Number, default: 12},
    numberSize: {type: Number, default: 21},
    innerOffset: {type: Number, default: 45},
    outerOffset: {type: Number, default: 15},
    startHour: {type: Number, default: 0},
    endHour: {type: Number, default: 23},
  },
  data(){
    let hours = [], minutes = [];
    for(let i = 0; i <= 23; i++){
      hours.push(i);
    }
    for(let i = 0; i * 5 < 60; i++){
      minutes.push(i * 5);
    }
    return {
      hours,
      minutes,
    }
  },
  computed: {
    radius(){
      return this.size / 2;
    },
    innerRadius(){
      return this.size / 2 - this.innerOffset;
    },
    outerRadius(){
      return this.size / 2 - this.outerOffset;
    },
    innerValue(){
      return this.value.split(':');
    }
  },
  methods: {
    pickHour(hour){
      if(hour >= this.startHour && hour < this.endHour){
        this.$emit('input', `${hour}:${this.innerValue[1]}`);
      }
    },
    pickMinute(minute){
      this.$emit('input', `${this.innerValue[0]}:${minute}`);
    },
  }
}
</script>

<style lang="scss" scoped>
.dol-clock{
  .dol-clock-plate{
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 50%;
    position: relative;

    .dol-clock-item{
      position: absolute;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      text-align: center;
      cursor: pointer;

      &:hover{
        background: #eeeeee;
      }

      &.active{
        color: #FFFFFF;
        background: #2075CF;
      }
      &.disabled{
        color: #cccccc;
        background: transparent;
        cursor: default;
      }
    }
  }
}
</style>
